import { render, staticRenderFns } from "./DataField.vue?vue&type=template&id=0fec6bee&scoped=true&"
import script from "./DataField.vue?vue&type=script&lang=js&"
export * from "./DataField.vue?vue&type=script&lang=js&"
import style0 from "./DataField.vue?vue&type=style&index=0&id=0fec6bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec6bee",
  null
  
)

export default component.exports